<template>
  <div>
    <RenewalNavbar />
    <div class="subscription-plan">
      <div class="subscription-plan__title-row">
        <div class>
          <router-link
            class="subscription-plan__title-row__back-button"
            v-if="
              $route.name !== 'Renewal Success' &&
                $route.name !== 'Renewal Failure'
            "
            :to="{ name: 'Dashboard' }"
          >
            Close
          </router-link>
        </div>
        <h3 class="subscription-plan__title-row__title">Subscription Plan</h3>
      </div>
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import RenewalNavbar from "./RenewalNavbar";
export default {
  name: "RenewSubscription",
  components: {
    RenewalNavbar
  }
};
</script>
<style lang="scss" scoped>
.subscription-plan {
  display: grid;
  padding: 17px 0;
  justify-content: center;
  grid-template-columns: minmax(min-content, 800px);
  grid-template-rows: auto min-content;
  &__title-row {
    display: grid;
    grid-template-columns: auto 1fr;
    align-content: center;
    align-items: center;
    text-align: center;
    margin-bottom: 18px;
    position: relative;
    &__back-button {
      border: solid 0.8px #166efa;
      border-radius: 4px;
      font-size: 14px;
      color: #166efa;
      padding: 6px 25px;
      background: transparent;
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }
    &__title {
      margin-bottom: 0;
      font-size: 20px;
      font-weight: bold;
      color: #4d4d4d;
    }
  }
}
</style>
